<template>
  <div>
    <!-- 产品增加 -->
    <!-- <el-dialog :title="operate === 'edit' ? '编辑产品' : '添加产品'" :close-on-click-modal="false" :visible="currentStep === 4"
      class="imgbox" width="1000px" :append-to-body="true" :before-close="closeDialog"> -->
    <el-form label-width="130px" ref="ruleForm">
      <div class="ele-row">
        <!-- <div class="ele-title">IOS</div> -->
        <div class="ele-content">
          <keep-alive>
            <uploadProductPic :data="uploadPic.ios" businessType="0" />
          </keep-alive>
        </div>
      </div>


      <!-- <div class="ele-row">
        <div class="ele-title">安卓</div>
        <div class="ele-content">
          <keep-alive>
            <uploadProductPic v-if="operate === 'edit'" :data="uploadPic.android" businessType="1" />
            <uploadProductPic :data="uploadPic.android" businessType="1" />
          </keep-alive>
        </div>
      </div>

      <div class="ele-row">
        <div class="ele-title">面板</div>
        <div class="ele-content">
          <keep-alive>
            <uploadProductPic v-if="operate === 'edit'" :data="uploadPic.panel" businessType="2" />
            <uploadProductPic :data="uploadPic.panel" businessType="2" />
          </keep-alive>
        </div>
      </div> -->

    </el-form>

    <div slot="footer" class="dialog-footer" v-if="operate === 'edit'">
      <el-button type="primary" @click="nextStep('update')">修改</el-button>
    </div>
    <div v-else slot="footer" class="dialog-footer" style="text-align: center;">
      <!-- <el-button @click="prevStep">上一步</el-button> -->
      <!-- <el-button type="primary" @click="nextStep">新增</el-button> -->
    </div>
    <!-- </el-dialog> -->
  </div>
</template>
<script>
import { addProduct, editProduct } from '@/api/productRegistration'
import uploadProductPic from '@/components/product_control/addProductDialog/uploadProductPic'
import eventBus from '@/assets/js/eventBus'
export default {
  props: {
    operate: {
      type: String
    },
    currentStep: {
      type: Number
    },
    productDetail: {
      type: Object
    },
    expandDto: {
      type: Object
    }
  },
  components: {
    uploadProductPic
  },
  data() {
    return {
      activeName: 'ios',
      uploadPic: {
        ios: {
          outPicList: [
            {
              id: new Date().getTime() + Math.random(),
              fileName: '',
              fileToken: '',
              fileDesc: '',
              businessType: 0// 业务类型(0:ios；1:安卓；2:中控面板；3:协议文件；4:其他)
            }
          ],
          validate: true,
          isActive: true// 记录是否渲染
        },
        // android: {
        //   outPicList: [
        //     {
        //       id: new Date().getTime() + Math.random(),
        //       fileName: '',
        //       fileToken: '',
        //       fileDesc: '',
        //       businessType: 1// 业务类型(0:ios；1:安卓；2:中控面板；3:协议文件；4:其他)
        //     }
        //   ],
        //   validate: true,
        //   isActive: false// 记录是否渲染
        // },
        // panel: {
        //   outPicList: [
        //     {
        //       id: new Date().getTime() + Math.random(),
        //       fileName: '',
        //       fileToken: '',
        //       fileDesc: '',
        //       businessType: 2// 业务类型(0:ios；1:安卓；2:中控面板；3:协议文件；4:其他)
        //     }
        //   ],
        //   validate: true,
        //   isActive: false// 记录是否渲染
        // }
      }
    }
  },
  created() {
    eventBus.$on('resetFields', this.resetFields)
    if (this.currentStep === 4 && this.operate === 'edit') {
      // console.log(9999)
      this.initData()
    }
  },
  watch: {
    currentStep() {
      if (this.currentStep === 4 && this.operate === 'edit') {
        // console.log(9999)
        this.initData()
      }
    }
  },
  methods: {
    update() {
      const params = Object.assign({}, this.productDetail)
      const expandDto = Object.assign({}, params.expandVo)
      // 删除多余参数
      delete params.expandVo
      if (expandDto && expandDto.agreementFile) {
        delete expandDto.agreementFile
      }
      params.expandDto = expandDto
      console.log('更新的params：', params)
      editProduct({ params: params }).then(
        res => {
          if (res.data.code === 200) {
            this.$message({
              type: 'success',
              message: '产品更新成功'
            })
            this.$emit('delImg')
            this.$emit('closeDialog', 1)
          }
        }
      )
    },
    initData() {
      //  const fileList = this.expandDto.fileList
      const iosList = []; const androidList = []; const panelList = []
      this.expandDto.fileLists.map(item => {
        const picItem = {
          id: item.fileId,
          fileName: item.fileName,
          fileToken: item.fileToken,
          fileDesc: item.fileDesc,
          businessType: item.businessType, // 业务类型(0:ios；1:安卓；2:中控面板；3:协议文件；4:其他)
          fileList: [{
            fileUrl: item.fileUrl
          }],
          createTime: item.createTime,
          productKey: item.productKey
        }

        if (item.businessType === 0) {
          iosList.push(picItem)
        } 
        // else if (item.businessType === 1) {
        //   androidList.push(picItem)
        // } else if (item.businessType === 2) {
        //   panelList.push(picItem)
        // }
      })
      this.uploadPic.ios.outPicList = iosList
      this.uploadPic.android.outPicList = androidList
      this.uploadPic.panel.outPicList = panelList
    },
    resetFields() {
      if (this.$refs.ruleForm) {
        this.$refs.ruleForm.resetFields()
      }
    },
    prevStep() {
      this.$emit('prevStep', 3)
    },
    handleClick(tab, event) {
      // console.log(tab, event)
      this.uploadPic[tab.name].isActive = true
    },
    addUploadFile() {
      const fileItem = { id: new Date().getTime() + Math.random(), fileList: [] }
      this.uploadFileList.push(fileItem)
    },
    closeDialog() {
      this.$emit('closeDialog')
    },
    nextStep(update) {
      // 每次验证前先把标记置为true
      this.uploadPic.ios.validate = true
      // this.uploadPic.android.validate = true
      // this.uploadPic.panel.validate = true
      eventBus.$emit('validatePicList');

      // 验证文件列表是否都通过
      if (update === 'validate') {
        let xx = this.uploadPic.ios.validate;
        if (!this.uploadPic.ios.validate) {
          this.activeName = 'ios';
          return false;
        }
        // if (!this.uploadPic.android.validate) {
        //   this.activeName = 'android'
        //   this.uploadPic.android.isActive = true
        //   return false;
        // }
        // if (!this.uploadPic.panel.validate) {
        //   this.activeName = 'panel'
        //   this.uploadPic.panel.isActive = true
        //   return false;
        // }
        return true;
      }  

      // 非编辑情况下
      // if (this.operate !== 'edit') {
      //   if (!this.uploadPic.android.isActive) {
      //     this.activeName = 'android'
      //     this.uploadPic.android.isActive = true
      //     return false;
      //   }
      //   if (!this.uploadPic.panel.isActive) {
      //     this.activeName = 'panel'
      //     this.uploadPic.panel.isActive = true
      //     return false;
      //   }
      // }

      let iosFileList = []; let androidFileList = []; let panelFileList = []
      // 组装数据
      if (this.uploadPic.ios.outPicList.length > 0) {
        iosFileList = this.uploadPic.ios.outPicList.map(item => {
          const returnItem = {
            fileName: item.fileName,
            fileToken: item.fileToken,
            fileDesc: item.fileDesc,
            businessType: item.businessType// 业务类型(0:ios；1:安卓；2:中控面板；3:协议文件；4:其他)
          }
          if (item.createTime) {
            returnItem.createTime = item.createTime
            returnItem.fileId = item.id
            returnItem.productKey = item.productKey
          }
          return returnItem
        })
      }

      // if (this.uploadPic.android.outPicList.length > 0) {
      //   androidFileList = this.uploadPic.android.outPicList.map(item => {
      //     const returnItem = {
      //       fileName: item.fileName,
      //       fileToken: item.fileToken,
      //       fileDesc: item.fileDesc,
      //       businessType: item.businessType// 业务类型(0:ios；1:安卓；2:中控面板；3:协议文件；4:其他)
      //     }
      //     if (item.createTime) {
      //       returnItem.createTime = item.createTime
      //       returnItem.fileId = item.id
      //       returnItem.productKey = item.productKey
      //     }
      //     return returnItem
      //   })
      // }

      // if (this.uploadPic.panel.outPicList.length > 0) {
      //   panelFileList = this.uploadPic.panel.outPicList.map(item => {
      //     const returnItem = {
      //       fileName: item.fileName,
      //       fileToken: item.fileToken,
      //       fileDesc: item.fileDesc,
      //       businessType: item.businessType// 业务类型(0:ios；1:安卓；2:中控面板；3:协议文件；4:其他)
      //     }
      //     if (item.createTime) {
      //       returnItem.createTime = item.createTime
      //       returnItem.fileId = item.id
      //       returnItem.productKey = item.productKey
      //     }
      //     return returnItem
      //   })
      // }
      if (this.operate !== 'edit') {
        this.productDetail.expandDto.fileLists = this.productDetail.expandDto.agreementFile.concat(iosFileList).concat(androidFileList).concat(panelFileList)
      } else {
        const fileList = iosFileList.concat(androidFileList).concat(panelFileList)
        // 加入协议文件
        this.expandDto.fileLists.map(item => {
          if (item.businessType === 3) {
            fileList.push(item)
          }
        })
        this.expandDto.fileLists = fileList
      }
      let x = this.productDetail;
      debugger;
      const expandDto = Object.assign({}, this.productDetail.expandDto)
      // 删除不必要的数据
      delete expandDto.agreementFile;  
      expandDto.offlineInstructions = this.productDetail.offlineInstructions;
      delete this.productDetail.offlineInstructions;
      const params = Object.assign({}, this.productDetail, { expandDto: expandDto });
      // todo调用接口
      console.log('请求params：', params)
      if (update === 'update') {
        this.update()
      } else {
        addProduct({ params: params }).then(
          res => {
            if (res.data.code === 200) {
              this.$message({
                type: 'success',
                message: '产品创建成功'
              })
              this.$emit('delImg')
              this.$emit('closeDialog', 1)
              this.$refs.ruleForm.resetFields()
            }
          }
        )
      }

      // 验证通过
      // this.closeDialog()
      // this.$refs.ruleForm.validate((valid) => {
      //   if (valid) {
      //     this.closeDialog()
      //   }
      // })
    },
    // 重置
    resetForm(formName) {
      this.$refs[formName].resetFields()
    }
  }
}
</script>

<style lang='less' scoped>
.ele-row {
  .ele-title {
    font-size: 16px;
    font-weight: 600;
  }

  .ele-content {}
}

.avatar-uploader-icon {
  font-size: 14px;
  color: white;
  width: 50px;
  height: 50px;
  line-height: 50px;
  text-align: center;
  background-color: #409EFF;
  border-radius: 25px;
  cursor: pointer;
}

.el-button {
  margin-left: 10px;
}
</style>
